import { useSelector } from "react-redux";
import { useMemo } from "react";
import { wrapper } from "../../redux";
import {
  fetchReviews,
  fetchRightNews,
  fetchVideos,
} from "../../redux/action-creaters/content";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import RightSide from "/components/layouts/rightSide";
import News from "../../components/side/news";
import styles from "./index.module.scss";
import Videos from "/components/side/videos";
import Redis from "/lib/redis";
import { Api } from "/api";
import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { checkIsBaltex } from "../../utils";
import BaltexReviews from "../../components/baltex/reviews";
import { sspWrapper } from "../../utils/errors/sspWrapper";
import ReviewsVidget from "../../components/main/reviewsVidget";

export default function ReviewsPage({
  scripts,
  host,
  baltexReviews = [],
  isBaltex,
  isFarkop,
}) {
  const { reviews } = useSelector((state) => state.content);
  const { cityName } = useSelector((state) => state.location);

  const reviewsSorted = useMemo(() => {
    let sort = "PROPERTY_REGION_SORT_VALUE";
    if (cityName === "Москва") {
      sort = "PROPERTY_MSK_SORT_VALUE";
    } else if (cityName === "Санкт-Петербург") {
      sort = "PROPERTY_SPB_SORT_VALUE";
    }
    return reviews.sort((a, b) => {
      return parseInt(a[sort], 10) - parseInt(b[sort], 10);
    });
  }, [reviews, cityName]);

  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <RightSide
        side={
          <>
            {isFarkop && <Videos />}
            {isFarkop && <News />}
          </>
        }
        title="Отзывы"
      >
        {isBaltex && <BaltexReviews items={baltexReviews} />}
        {isFarkop && (
          <div>
            <ReviewsVidget isShowTitle={false} />
            {reviewsSorted.map((review) => (
              <>
                {review.PROPERTY_TYPE_VALUE === "Виджет" && (
                  <div className={styles.Item} key={review.ID}>
                    <h3>{review.NAME}</h3>
                    <div
                      className={styles.Frame}
                      dangerouslySetInnerHTML={{
                        __html: review["~PREVIEW_TEXT"],
                      }}
                    />
                  </div>
                )}
              </>
            ))}
          </div>
        )}
      </RightSide>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ req, query, resolvedUrl }) => {
    const data = {};
    const reset = Boolean(query.reset);
    const { host } = req.headers;
    if (checkIsBaltex(host)) {
      data.baltexReviews = await Api.baltex.getReviews(Redis, reset);
    }
    await store.dispatch(await fetchReviews(Redis));
    await store.dispatch(await fetchRightNews(Redis));
    await store.dispatch(await fetchVideos(Redis));
    store.dispatch(addBreadcrumb({ link: "/reviews/", name: "Отзывы" }));

    return pagesWrapper(
      { ...data, pageType: SITE_PAGE_TYPE.static },
      store,
      Redis,
      {
        query,
        req,
        resolvedUrl,
      },
      "/reviews/",
    );
  }),
);
